import Vue from 'vue';
import VeeValidate from 'vee-validate';
import Select from 'vue-select';
import SignUp from './components/SignUp.vue';

Vue.use(VeeValidate, {
	events: ''
});
Vue.component('v-select', Select);

// Signup is disabled for internet explorer
var isIE = /*@cc_on!@*/false || !!document.documentMode; 

if (isIE == true) { 
	// Recommended targeting elements using 'data-ie' attributes
	$('[data-ie-disable]').hide();
	$('[data-ie-message]').show();
} else {
	new Vue({
		render: (h) => {
			return h(SignUp);
		}
	}).$mount('#signup-form');
};